import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ChatToMeConversationItem from './ChatToMeConversationItem';
import Loading from '../common/Loading.js';
import ToastrService from '../../services/toastrService';
import ErrorMessage from '../common/ErrorMessage';

class ChatToMeConversation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.canComment = this.canComment.bind(this);
        this.replyToComment = this.replyToComment.bind(this);
        this.state = {
            replyText: ''
        };
    }

    componentDidMount() {  
        window.componentHandler.upgradeDom();
    }

    componentWillUpdate(nextProps) {
        if(this.props.artist && nextProps.artist && this.props.artist.ConversationStatus !== nextProps.artist.ConversationStatus && nextProps.artist.ConversationStatus === 'FAILED') {
            this.setState({ error: 'Sorry, something went wrong. Unable to load this conversation.'});
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.activeProfile !== this.props.activeProfile || prevProps.conversation !== this.props.conversation) {
            //our reply button may have just been added
            window.componentHandler.upgradeDom();
        }        
    }

    canComment() {
        //this should also check if we're part of the conversation
        if(this.props.activeProfile && this.props.conversation && this.props.artist && this.props.artist.ConversationStatus !== 'FAILED') {
            const isActiveProfile = this.props.activeProfile.ID === this.props.artist.RoleID;
            const conversation = this.props.conversation;
            //if we're replying to another user from our page, we're not checking we have access to, but the server will reject if we can't
            const isCounterProfile = !isActiveProfile && conversation.Conversation.find(c => c.AuthorRoleID === this.props.activeProfile.ID) != null;
            return isActiveProfile || (isCounterProfile && this.props.artist.CommentsEnabled);
        }
        return false;
    }

    replyToComment(event) {
        event.preventDefault();
        if(!this.state.replyText) {
            this.setState({ error: 'Please enter a reply' });
        }
        else {
            let recipient = null;
            const isActiveProfile = this.props.activeProfile.ID === this.props.artist.RoleID;
            const conversation = this.props.conversation;
            const counterParty = conversation.Conversation.find(c => c.AuthorRoleID !== this.props.activeProfile.ID);
            if(isActiveProfile) {
                recipient = counterParty.AuthorUsername;
            }
            else {
                recipient = this.props.artist.Username;
            }
            this.props.actions.addComment(recipient, this.props.activeProfile.ID, this.state.replyText)
                .then(comment => {
                    const toastrService = new ToastrService();
                    toastrService.showSuccess('', `Your reply has been saved successfully${!comment.Approved ? ' and is pending approval': ''}`);
                    //reload the conversation
                    this.props.actions.getConversation(this.props.artist.Username, counterParty.AuthorUsername);
                    this.setState({ replyText: '', error: null });
                })
                .catch(error => this.setState({ error: error.message }));   
        }       
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        const conversation = this.props.conversation;
        return (
            <div>                
                <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                {this.canComment() ?  
                    <form id="frmReplyComment" onSubmit={this.replyToComment} className="form-regular">
                        <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={{width:"100%"}}>   
                            <textarea className="mdl-textfield__input" cols="20" required id="Text" name="Text" rows="2" maxLength="300" value={this.state.replyText} onChange={(e) => this.setState({ replyText: e.target.value })} />               
                            <label className="mdl-textfield__label" htmlFor="Text">Comment:</label>
                        </div>
                        <div className="form-group">
                            <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" disabled={!this.canComment()} value="Reply" />
                        </div>
                    </form>
                :
                    null
                }

                <ul id="ulComments" className="list-unstyled itemlist commentlist">
                    {conversation && conversation.Conversation.length > 0 ?
                        conversation.Conversation.map((comment) => <ChatToMeConversationItem key={comment.ID} comment={comment} artist={artist} actions={actions} />)
                    :
                    (artist.ConversationStatus == 'LOADING' ?
                        <Loading /> : null)}     
                </ul>
            </div>
        );
    }
}

ChatToMeConversation.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    conversation: PropTypes.object,
    activeProfile: PropTypes.object
};

export default ChatToMeConversation;